import React, { Component } from 'react';
import { SlideBar } from '.';
import MainOverView from './MainOverView';
import VisionView from "./VisionView";
class VisionDetails extends Component {
	constructor(props) {
        super(props);
        this.state = {
            itembox: [
                {
                    id: 1,
					title: 'Vision and Mission',
					classicon: 'icon-benefit',
					boxcontent: 'We are a Tanzanian based company that provides a wide range of services in the fields of ICT and Engineering.'
				},
            ]
        }
    }
    render() {
        return (
			
			<section className="flat-row pd-about-post">
                        <div className="container">
                            <div className="row flat-tabs" data-effect ="fadeIn">
								<SlideBar />
                                <VisionView />
                            </div>				
                        </div>
			        </section>
                    // flat-row-iconbox
        );
    }
}

export default VisionDetails;